import { createFileRoute } from '@tanstack/react-router'
import { ChallengeDetailPage } from '../../../components/AdminChallenges/ChallengeDetail'

export const Route = createFileRoute('/admin/challenges/$slug')({
  component: AdminChallengeDetailRoute,
})

function AdminChallengeDetailRoute() {
  const { slug } = Route.useParams()
  return <ChallengeDetailPage slug={slug} />
}
